export default __webpack_public_path__ + "static/media/calconvert_background_xl2.786d4e59.jpg";